module.exports = __webpack_public_path__ + "img/s2-hx-1.8b75ebf0.png";